import { Button, Spinner } from 'react-bootstrap';
import { DateTime as DT } from 'luxon';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import { UserNameItem } from 'modules/user';
import { format$Price, formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency } from 'utils/helpers/currency/currencyHelpers';
import vconst from 'utils/helpers/structs/vconst';
import type { IncomeExpenseRow } from '../model';

interface ExpensesTableRowProps {
    row: IncomeExpenseRow;
    readOnly: boolean;
    deleting: boolean;
    deleteLocked: boolean;
    onDelete: (row: IncomeExpenseRow) => void;
}

const ExpensesTableRow = ({ row, readOnly, deleting, deleteLocked, onDelete }: ExpensesTableRowProps) => {
    const { t } = useTranslation(['Objects']);
    const cancelled = Number(row.status) === vconst.incomeStatCancel;
    const dt = row.dt ? DT.fromMillis(row.dt).toLocaleString(DT.DATE_MED) : '—';
    const dtCancel = row.dtCancel ? DT.fromMillis(row.dtCancel).toLocaleString(DT.DATE_MED) : '';

    return (
        <tr className={cancelled ? 'bg-light-danger' : undefined}>
            <td className="username">
                <UserNameItem
                    smallMode
                    user={{
                        userName: row.userName,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture || undefined,
                    }}
                />
            </td>
            <td className="date">
                <span className="d-block">{dt}</span>
                {cancelled && dtCancel ? (
                    <p className="text-danger fw-medium fs-12 mb-0 my-1 text-truncate">{dtCancel}</p>
                ) : null}
            </td>
            <td className="amount">
                <span className="d-block">{format$Price(row.amount)}</span>
                <p className="text-muted fs-12 mb-0">{withLocalCurrency(formatPrice(row.amountRate))}</p>
            </td>
            <td className="note">
                <span className="text-break" style={{ whiteSpace: 'pre-wrap' }}>
                    {row.comment || '—'}
                </span>
            </td>
            <td className="action text-end">
                {!readOnly && !cancelled ? (
                    <Button
                        type="button"
                        size="sm"
                        className="py-0 px-1 mb-1"
                        variant="light-danger"
                        title={t('expendTeamExpenses.remove')}
                        disabled={deleteLocked && !deleting}
                        onClick={() => onDelete(row)}
                    >
                        {deleting ? (
                            <Spinner as="span" animation="border" size="sm" role="status" />
                        ) : (
                            <SolarIcon name="trash3" />
                        )}
                    </Button>
                ) : null}
            </td>
        </tr>
    );
};

export default ExpensesTableRow;
